<template>
  <el-form ref="userItaProfileForm" :model="user" v-loading="formLoading">
    <el-form-item label="帳號">
      <el-input v-model.trim="user.account" :disabled="true" />
    </el-form-item>

    <el-form-item label="名稱">
      <el-input v-model.trim="user.name" :disabled="checkPermission(['ITA-TRAVEL-AGENCY'])" />
    </el-form-item>

    <el-form-item label="更改密碼" prop="password">
      <!-- <span class="svg-container">
        <svg-icon icon-class="password" />
      </span> -->

      <span class="show-pwd" @click="showPwd" style="margin-left: 10px">
        <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
      </span>
      <el-row>
        <el-tag type="warning" style="height: auto; white-space: break-spaces; font-size: 14px"
          >密碼原則：密碼必須包含英文，數字及長度介於6-16之間</el-tag
        >
      </el-row>
      <el-input
        ref="password"
        v-model="user.password"
        :type="passwordType"
        placeholder="請輸入密碼"
        autocomplete="off"
      />
      <!-- <i style="color: blue; font-size: 12px; margin: 5px"
        >密碼原則：密碼必須包含英文，數字及長度介於6-16之間。</i
      > -->
    </el-form-item>

    <!-- <el-form-item label="Email">
      <el-input v-model.trim="user.email" />
    </el-form-item> -->
    <el-form-item>
      <el-button type="warning" @click="submit" style="color: #4b4b4b">儲 存</el-button>
    </el-form-item>

    <el-form-item v-if="errorMsg">
      <el-alert :closable="false" :title="errorMsg" type="error"> </el-alert>
    </el-form-item>
  </el-form>
</template>

<script>
import { saveUserProfileData } from '@/api/member'
import checkPermission from '@/utils/permission' // 权限判断函数

export default {
  props: {
    user: {
      type: Object,
      default: () => {
        return {
          account: '',
          name: '',
          password: null,
        }
      },
    },
  },
  data() {
    return {
      errorMsg: null,
      formLoading: false,
      passwordType: 'password',
      // rules: {
      //   password: [{ required: true, message: "請輸入密碼", trigger: "blur" }],
      // },
    }
  },
  created() {},
  methods: {
    checkPermission,
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    async submit() {
      if (!confirm(`確定要更新資料?`)) {
        return
      }
      let vm = this
      this.$refs.userItaProfileForm.validate(async valid => {
        this.errorMsg = ''
        // let roles = vm.user.role.split("|"); -- 多於錯誤程式碼
        const { id, name, password } = vm.user
        let payload = { id, name, password }
        if (valid) {
          vm.formLoading = true
          try {
            let resp = await saveUserProfileData(payload)
            this.$message({
              message: '資料處理完成',
              type: 'success',
            })
          } catch (error) {
            if (error.data.message) {
              this.errorMsg = error.data.message
            }
          } finally {
            vm.formLoading = false
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>
